import React from 'react';
import { useTranslation } from 'react-i18next';
import './Features.css';

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '📅',
      title: t('feature1Title'),
      description: t('feature1Description'),
    },
    {
      icon: '👥',
      title: t('feature2Title'),
      description: t('feature2Description'),
    },
    {
      icon: '📢',
      title: t('feature3Title'),
      description: t('feature3Description'),
    },
    {
      icon: '📈',
      title: t('feature4Title'),
      description: t('feature4Description'),
    },
    {
      icon: '✓',
      title: t('feature5Title'),
      description: t('feature5Description'),
    },
    {
      icon: '⭐',
      title: t('feature6Title'),
      description: t('feature6Description'),
    },
  ];

  return (
    <section id="features" className="features" aria-label="Features section">
      <div className="container">
        <h2 className="section-title">{t('whatWeDo')}</h2>
        <p className="section-subtitle">{t('whatWeDoDescription')}</p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <article key={index} className="feature-card">
              <div 
                className="feature-icon"
                style={index === 3 ? { filter: 'hue-rotate(120deg) saturate(1.3) brightness(1.1)' } : {}}
                aria-hidden="true"
                role="img"
                aria-label={`${feature.title} icon`}
              >
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
